import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { NavigationCancel, NavigationEnd, Router, RouterModule } from '@angular/router';
import { Subscription } from 'rxjs/internal/Subscription';

@Component({
	selector: 'app-content',
	templateUrl: './content.component.html',
	styleUrls: ['./content.component.scss'],
	imports: [CommonModule, RouterModule],
	standalone: true,
})
export class ContentComponent implements OnInit, OnDestroy {
	@Input() contentContainerCSSClass = '';
	@Input() appContentContiner?: 'fixed' | 'fluid';
	@Input() appContentContainerClass = '';

	private unsubscribe: Subscription[] = [];

	private router = inject(Router);

	ngOnInit(): void {
		this.routingChanges();
	}

	routingChanges() {
		const routerSubscription = this.router.events.subscribe((event) => {
			if (event instanceof NavigationEnd || event instanceof NavigationCancel) {
				// DrawerComponent.hideAll();
			}
		});
		this.unsubscribe.push(routerSubscription);
	}

	ngOnDestroy() {
		this.unsubscribe.forEach((sb) => sb.unsubscribe());
	}
}
